/* eslint-disable class-methods-use-this */
/* eslint-disable no-undef */
import {
  CURRENT_USER, NAME, ORGANIZATION_ID, ORGANIZATION_USER_ID, USER_ROLE,
} from './client/constants/session-storage-keys';
import ThirdPartyScripts from './client/constants/third-party-scripts';
import { EnvTypes } from './client/utils/base-url-util';
import { getEnvironment } from './client/utils/env-utils';
import { loadScript } from './client/utils/script-loader-util';
import { getFromSessionStorage } from './client/utils/session-storage-utils';

class AppGuide {
  constructor() {
    if (AppGuide.instance) {
      // eslint-disable-next-line no-constructor-return
      return AppGuide.instance;
    }
    AppGuide.instance = this;
  }

  loadAppGuideScript() {
    loadScript({ innerScript: ThirdPartyScripts.PENDO });
  }

  intializeAppGuide() {
    const organizationId = getFromSessionStorage(ORGANIZATION_ID);

    if (pendo) {
      const role = getFromSessionStorage(USER_ROLE);
      const orgUserId = getFromSessionStorage(ORGANIZATION_USER_ID);
      const { plan } = getFromSessionStorage(CURRENT_USER);

      const getPrefixId = (id) => {
        const stageEnv = getEnvironment();

        if (stageEnv === EnvTypes.PREPROD || stageEnv === EnvTypes.SANDBOX) {
          return `${stageEnv}-${orgUserId}`;
        } return id;
      };

      pendo.initialize({
        visitor: {
          id: getPrefixId(orgUserId),
          firstName: getFromSessionStorage(NAME),
          role,
          plan,
        },

        account: {
          id: getPrefixId(organizationId),
          role,
          plan,
        },
      });
    }
  }
}

export default AppGuide;
